import classNames from 'classnames';
import { Section, useViewport } from '@farmersdog/corgi-x';
import { useTrackedSectionRef } from '../../../../hooks/useTrackedSections';
import { HomepageRedesignSections } from '../CtaTrackerV2';
import { BowlPackSectionDesktop } from './components/BowlPackSectionDesktop';
import { BowlPackSectionMobile } from './components/BowlPackSectionMobile';
import { VetsNegativeBowlPackSection } from './components/VetsNegativeBowlPackSection';
import { VetsPositiveBowlPackSection } from './components/VetsPositiveBowlPackSection';
import { useShowHomepageRedesign } from 'src/hooks/useHomepageRedesign';
import styles from './BowlPackSection.module.css';

export const BowlPackSection = () => {
  const sectionRef = useTrackedSectionRef(HomepageRedesignSections.BowlPack);

  const { isOlsTreatment, isVetsNegativeTreatment, isVetsPositiveTreatment } =
    useShowHomepageRedesign();
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <Section
      aria-labelledby="bowl-pack-section-heading"
      className={classNames(styles.wrapper, {
        [styles.wrapperVetsNegative]: isVetsNegativeTreatment,
        [styles.wrapperVetsPositive]: isVetsPositiveTreatment,
      })}
      sectionRef={sectionRef}
    >
      {isOlsTreatment &&
        (isMobile ? <BowlPackSectionMobile /> : <BowlPackSectionDesktop />)}
      {isVetsNegativeTreatment && <VetsNegativeBowlPackSection />}
      {isVetsPositiveTreatment && <VetsPositiveBowlPackSection />}
    </Section>
  );
};
